import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ModalMessageComponent } from 'src/app/components/common/modalmessage/modalmessage.component';
import { Experiencia } from 'src/app/interfaces/experiencia';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { ExperienciaService } from 'src/app/services/experiencia/experiencia.service';

@Component({
  selector: 'app-experience-candidate',
  templateUrl: './experience-candidate.component.html',
  styleUrls: ['./experience-candidate.component.scss']
})
export class ExperienceCandidateComponent implements OnInit {

  usuario: JwtResponse;
  experiencias: Experiencia[];
  experienciaCandidato: Experiencia;
  mostrarEdicion: boolean;
  noPagina: number;
  formExp: FormGroup;
  editarExperiencia: boolean;
  disableAnioFin: boolean;
  mostrarExperiencia: boolean;

  constructor(private experienciaService: ExperienciaService, private modalService: NgbModal, private formBuilder: FormBuilder) {
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    this.experienciaCandidato = {} as Experiencia;
    this.editarExperiencia = false;
    this.disableAnioFin = false;
    this.mostrarExperiencia = false;
  }

  ngOnInit() {
    this.noPagina = 1;
    this.cargarExperienciasCandidato();
    this.crearFormularioExperiencia();
  }

  crearFormularioExperiencia(): void {
    this.formExp = this.formBuilder.group({
      empresaLaborada: [null, Validators.required],
      descripcion: [null, Validators.required],
      fechaInicio: [null, [Validators.maxLength(4), Validators.pattern(/^([0-9])*$/)]],
      fechaFin: [null, [Validators.maxLength(4), Validators.pattern(/^([0-9])*$/)]]
    });
  }

  async cargarExperienciasCandidato() {
    try {
      if(this.usuario && this.usuario.user){
        const response = await this.experienciaService.obtenerExperienciasPorIdCandidato(this.usuario.user.idUsuario);
        this.experiencias = response.data;
        if(this.experiencias.length == 0){
          this.mostrarEdicion = true;
        }else{
          this.experiencias.forEach((experiencia => {
            if(!experiencia.fechaFin && experiencia.fechaFin == 0){
              this.disableAnioFin = true;
            }
          }));
        }
      } 
    } catch (error) {
      console.error("Error al cargar las experiencias del canidato", error);
    }
  }

  validarExperiencia(): void {
    if(this.experienciaCandidato && this.experienciaCandidato.idExperiencia){
      this.actualizarExperienciaCandidato();
    }else{
      if(this.formExp.valid){
        this.registrarExperienciaCandidato();
      }
    }
  }

  registrarExperienciaCandidato(){
    const experiencia: Experiencia = {
      idExperiencia: null,
      empresaLaborada: this.formExp.get('empresaLaborada').value,
      descripcion: this.formExp.get('descripcion').value,
      fechaInicio: this.formExp.get('fechaInicio').value,
      fechaFin: this.formExp.get('fechaFin').value
    };

    this.experienciaService.registrarExperiencia(this.usuario.user.idUsuario, experiencia).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", mensajeError);
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.mostrarEdicion = false;
        this.abrirModalMessage("Éxito", "Se ha registrado correctamente.");
      } else {
        this.abrirModalMessage("Error", "No se ha registrado correctamente " + result.messageError);
        console.error('Error al registrar la experiencia del candidato: ', result.messageError);
      }
    });
  }

  actualizarExperienciaCandidato(){
    const experiencia: Experiencia = {
      idExperiencia: this.experienciaCandidato.idExperiencia,
      empresaLaborada: this.formExp.get('empresaLaborada').value || this.experienciaCandidato.empresaLaborada,
      descripcion: this.formExp.get('descripcion').value || this.experienciaCandidato.descripcion,
      fechaInicio: this.formExp.get('fechaInicio').value || this.experienciaCandidato.fechaInicio,
      fechaFin: this.formExp.get('fechaFin').value || this.experienciaCandidato.fechaFin
    };

    this.experienciaService.actualizarExperiencia(experiencia).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.experienciaCandidato = {} as Experiencia;
        this.abrirModalMessage("Error", mensajeError);
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.mostrarEdicion = false;
        this.abrirModalMessage("Éxito", "Se ha actualizado correctamente.");
      } else {
        this.abrirModalMessage("Error", "No se ha actualizado correctamente " + result.messageError);
        console.error('Error al actualizado la experiencia del candidato: ', result.messageError);
      }
    });
  }

  eliminarExperienciaCandidato(idExperiencia: number): void {
    if(this.usuario && this.usuario.user.idUsuario && idExperiencia){
      this.experienciaService.eliminarExperienciaPorId(this.usuario.user.idUsuario, idExperiencia).pipe(
        catchError(error => {
          let mensajeError = '';
          if (error.status === 0) {
            mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
            mensajeError += `Http error: ${error.message}`;
            console.error('se ha producido un error:', error.error);
          } else {
            mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
            mensajeError += `Http error: ${error.message}`;
            console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
          }
          this.abrirModalMessage("Error", mensajeError);
          return throwError(mensajeError);
        })
      ).subscribe(result => {
        if (result.success) {
          this.ngOnInit();
          this.mostrarEdicion = false;
          this.abrirModalMessage("Éxito", "Se ha eliminado correctamente.");
        } else {
          this.abrirModalMessage("Error", "No se ha eliminado correctamente " + result.messageError);
          console.error('Error al eliminar la experiencia del candidato: ', result.messageError);
        }
      });
    }
  }

  habilitarEdicion(experiencia: Experiencia): void{
    this.experienciaCandidato = {} as Experiencia;
    if(experiencia){
      this.mostrarEdicion = true;
      this.editarExperiencia = true;
      this.experienciaCandidato = experiencia;
    }
  }

  mostrarEdicionExperiencia(): void {
    this.mostrarEdicion = true;
    this.editarExperiencia = false;
    this.experienciaCandidato = {} as Experiencia;
    this.disableAnioFin = false;
  }

  inhabilitarCampoAnioFin(): void {
    this.disableAnioFin = !this.disableAnioFin;
  }

  cambioPaginaExperiencia(){
    let experiencia: Experiencia;

    for(let x = 0; x < this.experiencias.length; x++){
      if(x === (this.noPagina - 1)){
        experiencia = this.experiencias[x];
        this.disableAnioFin = (!experiencia.fechaFin ? true : false);
      }
    }
  }

  abrirModalMessage(modalTitle: string, modalMessage: string) {
    const modalRef = this.modalService.open(ModalMessageComponent, { centered: true });
    modalRef.componentInstance.modalTitle = modalTitle;
    modalRef.componentInstance.modalMessage = modalMessage;
  }

  mostrarExperienciaData(): void {
    this.mostrarExperiencia = !this.mostrarExperiencia;
  }

  cerrarExperienciaData(): void {
    this.mostrarExperiencia = false;
  }
}
